import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Waste skip.
export const DUMPSTER_NODES: IconNode = [
  [
    'path',
    {
      key: 'dumpster-0',
      d: 'M2.5 5.6001H21.5',
    },
  ],
  [
    'path',
    {
      key: 'dumpster-1',
      d: 'M4.5 5.6001L6.5 15.3001H17.5L19.5 5.6001',
    },
  ],
  [
    'path',
    {
      key: 'dumpster-2',
      d: 'M5.69995 9.8999H18.3',
    },
  ],
  [
    'path',
    {
      key: 'dumpster-3',
      d: 'M9.0001 18.4001C9.7733 18.4001 10.4001 17.7733 10.4001 17.0001C10.4001 16.2269 9.7733 15.6001 9.0001 15.6001C8.2269 15.6001 7.6001 16.2269 7.6001 17.0001C7.6001 17.7733 8.2269 18.4001 9.0001 18.4001Z',
    },
  ],
  [
    'path',
    {
      key: 'dumpster-4',
      d: 'M15.0001 18.4001C15.7733 18.4001 16.4001 17.7733 16.4001 17.0001C16.4001 16.2269 15.7733 15.6001 15.0001 15.6001C14.2269 15.6001 13.6001 16.2269 13.6001 17.0001C13.6001 17.7733 14.2269 18.4001 15.0001 18.4001Z',
    },
  ],
]

export const DumpsterIcon: LucideIcon = createLucideIcon(
  'dumpster',
  DUMPSTER_NODES,
)
